module.exports = __webpack_public_path__ + "static/video-0d5fd4035425c1872d9d91a756606c78.webp";